const API = 'api';

export const RestRoutes = {
  LANGUAGES: `${API}/Languages`,
  LANGUAGEMESSAGE: `${API}/Languages/LanguageMessage`,
  PAGES: `${API}/Pages`,
  USER: `${API}/user`,
  USERS: `${API}/v2/Users`,
  CONTACTGROUP: `${API}/v2/ContactGroups`, // SH GetSH_Paged
  AUTH: `${API}/auth`, // WS controller para peticiones auth
  AUTHv3: `${API}/v3/auth`, // WS controller para peticiones auth
  CLAIMOPERATIONS_GET: `${API}/v3/ClaimOperations/Search`, // SH ClaimOperationsGet_PanelCliente
  CLAIMOPERATIONS_GETINFO: `${API}/v2/ClaimOperations`,
  CLAIMOPERATIONS_GETBYUSER: `${API}/v3/ClaimOperations`, //LastRequiredElements
  CLAIMOPERATIONS_STATESCOUNT: `${API}/v2/ClaimOperations/StatesCount`,
  ATTACHED_FILES_GETBYCLAIM:`${API}/v1/AttachedFiles/getByClaim/{CLAIMID}/PanelCliente`, //DisputeManagement para obtener los documentos ya subidos
  //STATEMASTER_GETSTATES:`${API}/v1/StateMaster/GetState`, //Obtener stateName para el state del histórico
  STATEMASTER_GETSTATES:`${API}/v2/ClaimOperations/StatesCount`, //Obtener agrupaciones y count para estados
  STATEMASTER_GET:`${API}/v3/StateMaster`, //Obtener state y grupos de estado de disputa
  ATTACHED_FILES:`${API}/v3/AttachedFiles/`, //Descarga archivos. Diferencia con v1/AttachedFiles/getByClaim/{CLAIMID}/PanelCliente.
  DYNAMIC_FORM:`${API}/v1/DynamicForm`, //Se usa en disputeManagement
  STATE_TRANSITIONS: `${API}/v2/StateMaster/{ID}/transitions/Commerce`, //Se usa en detalle de disputa. Me sobra el /commerce. Entiendo que es el tipo de transiciones. Si en el endpoint es variable, en la definción de ruta sería variable y sustituir en otro sitio
  PW_RECOVER: `${API}/Auth/password/recover`,
  PW_RESET:  `${API}/Auth/password/reset`,
  CONFIRM_TRANSITION:`${API}/v3/ClaimOperations/confirm/`,
  COMMERCEFILES_CHANGEFILE: `${API}/v2/CommerceFiles/`,
  //COMMERCE_FILES_DOWNLOAD: `${API}/v1/CommerceFiles`, //TODO: ¿Porqué uno en cada versión?
  COMMERCE_FILES: `${API}/v2/CommerceFiles`, //TODO: Son todos iguales. O definimos ruta completa o solo Controlador, pero no se repite.
  COMMERCE_FILES_POST: `${API}/v2/CommerceFiles`,
  COMMERCE_FILES_GET: `${API}/v2/CommerceFiles`,
  COMMERCE_FILES_HISTORIC: `${API}/v2/CommerceFilesHistoric`, //TODO: ruta rara. Sería como ComerceFiles/{id}/history
  STATE_GET_ELEMENTLINKEDSTATES:`${API}/v2/StateMaster/{ID}/elementLinkedStates`,
  EMAILS_GET:`${API}/v2/Emails`,
  DISPUTE_SUBREASONS:`${API}/v1/SubReasons/PanelCliente`, //TODO: Ver donde se usa. No entiendo por qué lo tenemos.
  CLAIM_DISPUTES:`${API}/v2/ClaimOperations/{ID}/claimDisputes`,
  COMMERCE_FILES_TYPES_GET: `${API}/v2/CommerceFiles/types`,
  CONTACTS: `${API}/v2/Contacts`,
  DASHBOARD: `${API}/v3/Statistics/{METRICID}`,
}
